import * as types from './mutation-types'
import { cart as cartApi, order as orderApi } from 'glonass/shop/site/api'

// todo: httpActionHelper
export const putToCart = async ({commit}, items) => {
  const type = types.PUT_TO_CART

  commit(type + '_request')

  try {
    const {data} = await cartApi.put(items)
    commit(type + '_success', data)
  } catch (e) {
    console.error(e)
    commit(type + '_failed', e)
  }
}

export const removeFromCart = async ({commit}, items) => {
  const type = types.REMOVE_FROM_CART

  commit(type + '_request')

  try {
    const {data} = await cartApi.remove(items)
    commit(type + '_success', data)
  } catch (e) {
    console.error(e)
    commit(type + '_failed', e)
  }
}

export const createOrder = async ({commit}, payload) => {
  const type = types.CREATE_ORDER

  commit(type + '_request')

  try {
    const {data} = await orderApi.createOrder(payload)
    commit(type + '_success', data)
  } catch (e) {
    console.error(e)
    commit(type + '_failed', e)
  }
}




// WEBPACK FOOTER //
// ./dev-packages/Shop/assets/site/store/actions.js